import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién empiezo o ya tengo negocio?',
    a: 'Sí. Evitás malos hábitos al empezar o escalás si ya tenés experiencia.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Email con acceso PDF inmediato. Funciona desde celular o PC.'
  }, {
    q: '¿Funciona para cualquier rubro?',
    a: 'Sí, ideal para estéticas, coaches, freelancers y servicios.'
  }, {
    q: '¿Necesito saber de tecnología o diseño?',
    a: 'No. Si sabés usar WhatsApp, sabés usar esto con ChatGPT gratis.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, 7 días. Devolvemos el 100% sin preguntas.'
  }];
  return <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-102">
      <FadeIn data-id="element-103">
        <h2 className="text-2xl md:text-5xl font-black text-[#1a1611] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-104">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(201,169,97,0.2)]" data-id="element-105">
            ❓
          </span>{' '}
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-106">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-107" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-white border-[#c9a961] shadow-[0_5px_15px_rgba(201,169,97,0.1)]' : 'bg-white border-[#e8dfd0] hover:border-[#c9a961]/50 shadow-sm'}`} data-id="element-108">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-4 md:py-6 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-109">
        <span className={`font-black text-sm md:text-xl pr-2 md:pr-4 transition-colors ${isOpen ? 'text-[#b8860b]' : 'text-[#1a1611]'}`} data-id="element-110">
          {question}
        </span>
        <div className={`shrink-0 p-1.5 md:p-2 rounded-full transition-colors ${isOpen ? 'bg-[#c9a961]/20 text-[#b8860b]' : 'bg-[#f5f0e8] text-[#6b5d4f]'}`} data-id="element-111">
          {isOpen ? <Minus className="w-4 h-4 md:w-5 md:h-5" data-id="element-112" /> : <Plus className="w-4 h-4 md:w-5 md:h-5" data-id="element-113" />}
        </div>
      </button>
      <AnimatePresence data-id="element-114">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-115">
            <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-116">
              <p className="text-[#6b5d4f] leading-relaxed text-sm md:text-lg font-medium" data-id="element-117">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}